<template>
  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">SOP</div>
            <div
              style="margin-left: 10px"
              v-if="mode != this.$FORM_MODE_CREATE"
            >
              <Button
                type="button"
                icon="pi pi-info"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
                class="p-button-rounded p-button-outlined p-button-sm"
              />

              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="true"
                id="overlay_panel"
                style="width: 550px"
                :breakpoints="{ '960px': '80vw' }"
              >
                <div class="p-grid p-field">
                  <div class="p-row">
                    <i class="pi pi-plus-circle" />
                    {{ this.$formatDateTime(header.CreatedDate) }}
                  </div>
                  <div class="p-row">by {{ header.CreatedBy }}</div>
                </div>
                <div class="p-grid p-field" v-if="header.EditedDate">
                  <div class="p-row">
                    <i class="pi pi-pencil" />
                    {{ this.$formatDateTime(header.EditedDate) }}
                  </div>
                  <div class="p-row">by {{ header.EditedBy }}</div>
                </div>
              </OverlayPanel>
            </div>
          </template>

          <template #right>
            <Button
              icon="pi pi-chevron-left"
              :label="$t('back')"
              class="p-button mr-2"
              @click="backToIndex"
            />
            <Button
              icon="pi pi-save"
              :label="$t('save')"
              class="p-button-success"
              @click="confirm($event)"
              v-if="mode != this.$FORM_MODE_VIEW"
            />
            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <FormField :labelName="$t('code')" fieldName="Code" v-model="header">
            <InputText
              name="Code"
              :placeholder="$t('code')"
              v-model="header.Code"
              type="text"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <FormField
            :labelName="$t('permitname')"
            fieldName="PermitName"
            v-model="header"
          >
            <InputText
              name="PermitName"
              :placeholder="$t('permitname')"
              v-model="header.PermitName"
              type="text"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <div class="col-12">
            <DataTable
              :loading="!header"
              :value="header ? header.Details : null"
              responsiveLayout="scroll"
              class="p-datatable-sm editable-cells-table"
              :rowClass="hideRow"
            >
              <Column>
                <template #header="">
                  <Button
                    label=""
                    icon="pi pi-plus"
                    class="p-button-primary p-mr-2 p-button-sm"
                    @click="addDetail"
                    :disabled="!canEdit"
                  />
                </template>
                <template #body="slotProps">
                  <Button
                    icon="pi pi-minus"
                    class="p-button-danger p-mr-2 p-button-sm"
                    @click="deleteDetail(slotProps)"
                    :disabled="!canEdit"
                  />
                </template>
              </Column>
              <Column field="DocNo" :header="$t('docno')" key="DocNo">
                <template #body="slotProps">
                  <InputText
                    name="DocNo"
                    v-model="slotProps.data[slotProps.column.props.field]"
                    type="text"
                    :placeholder="$t('docno')"
                    :disabled="
                      (mode != this.$FORM_MODE_CREATE &&
                        mode != this.$FORM_MODE_EDIT) ||
                      slotProps.data.mode != this.$FORM_MODE_CREATE
                    "
                    @change="onCellEditComplete(slotProps)"
                  />
                </template>
              </Column>
              <Column field="Title" :header="$t('title')" key="Title">
                <template #body="slotProps">
                  <InputText
                    name="Title"
                    v-model="slotProps.data[slotProps.column.props.field]"
                    type="text"
                    :placeholder="$t('title')"
                    :disabled="
                      (mode != this.$FORM_MODE_CREATE &&
                        mode != this.$FORM_MODE_EDIT) ||
                      slotProps.data.mode != this.$FORM_MODE_CREATE
                    "
                    @change="onCellEditComplete(slotProps)"
                  />
                </template>
              </Column>
              <Column field="DocAsset" :header="$t('docasset')" Key="DocAsset">
                <template #body="slotProps">
                  <div class="p-fluid">
                    <CustomFileUpload
                      :fileModels="slotProps.data.files_data"
                      :multiple="false"
                      :showUploadButton="false"
                      :showCancelButton="false"
                      :customUpload="false"
                      accept="application/pdf"
                      @select="onFileSelect($event, slotProps.data)"
                      :maxFileSize="5000000"
                      :disabled="
                        (mode != this.$FORM_MODE_CREATE &&
                          mode != this.$FORM_MODE_EDIT) ||
                        slotProps.data.mode != this.$FORM_MODE_CREATE
                      "
                      @remove="onFileRemove($event, slotProps.data)"
                      @change="onCellEditComplete(slotProps)"
                      @input="onCellEditComplete(slotProps)"
                    />
                  </div>
                </template>
              </Column>
              <Column
                field="viewFiles1"
                :header="$t('download_currently')"
                Key="Id"
                style="width: 20px"
              >
                <template #body="slotProps">
                  <div class="p-fluid">
                    <CustomFileUpload
                      :fileModels="slotProps.data.viewFiles1"
                      :multiple="false"
                      :showUploadButton="false"
                      :showCancelButton="false"
                      :customUpload="false"
                      @select="onFileSelect"
                      @remove="onFileRemove"
                      :viewOnly="true"
                      :showHeader="false"
                      @download="onDownloadFile"
                    />
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </template>
    </Card>
  </form>
</template>

<script>
export default {
  name: "Editor",
  data() {
    return {
      indexName: "SopIndex",
      url: this.$API_URL + "sop/",
      header: null,
      detail: null,
      mode: "",
      id: 0,
      formEditable: true,
      dataModel: false,
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    getData() {
      var self = this;
      this.$axios
        .get(this.url + this.id + "/" + this.mode)
        .then((response) => {
          self.header = response.data.data.header;
          self.dataModel = response.data.data.detail;

          self.header.mode = self.mode;

          //console.log(self.header.Details);
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveData() {
      this.$emit("block-ui");
      var self = this;
      var data = new FormData();

      data.append("Id", this.header.Id);
      data.append("Code", this.header.Code);
      data.append("PermitName", this.header.PermitName);
      data.append("mode", this.header.mode);

      for (var i = 0; i < this.header.Details.length; i++) {
        var item = this.header.Details[i];

        if (item.mode != null)
          data.append("Details[" + i + "].mode", item.mode);
        if (item.Id != null) data.append("Details[" + i + "].Id", item.Id);
        if (item.RefId != null)
          data.append("Details[" + i + "].RefId", item.RefId);
        if (item.DocNo != null)
          data.append("Details[" + i + "].DocNo", item.DocNo);
        if (item.CompanyId != null)
          data.append("Details[" + i + "].CompanyId", item.CompanyId);
        if (item.Title != null)
          data.append("Details[" + i + "].Title", item.Title);
        if (item.PermitType != null)
          data.append("Details[" + i + "].PermitType", item.PermitType);
        if (item.DocAsset != null)
          data.append("Details[" + i + "].DocAsset", item.DocAsset);

        if (item.files_data != null) {
          for (var x = 0; x < item.files_data.length; x++) {
            var file = item.files_data[x];
            data.append("Details[" + i + "].attachments.File", file, file.name);
          }
        }
      }

      this.$axios
        .post(this.url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.$router.push({
              name: this.indexName,
              params: {
                showToast: true,
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              },
            });
          } else {
            this.showError("Error Saving Data", response.data.message);
          }
        })
        .catch(function (error) {
          this.showError("Error Saving Data", error);
        });
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    backToIndex() {
      this.$router.push({ path: "/Sop/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.saveData();
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.header.Details.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.header.Details[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.header.Details.splice(this.header.Details.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    onFileSelect(event, data) {
      data.files_data = [];

      //console.log(data)
      for (var i = 0; i < event.files.length; i++) {
        data.files_data.push(event.files[i]);
      }
    },
    onFileSelectUpload(event) {
      this.detailFiles = event.files;
      this.uploadFile = true;
    },
    onFileRemove(files, data) {
      data.files_data = [];
      for (var i = 0; i < files.length; i++) {
        data.files_data.push(event.files[i]);
      }
    },
    onDownloadFile(file) {
      //console.log(file)
      var self = this;
      this.$axios
        .get(this.url + "download_currently/" + file.id + "/" + file.name, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.name);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          //self.showAssignModal = false;
        });
    },
    editDetail(index) {
      if (this.header.Details && this.header.Details.length > 0) {
        let m = this.header.Details[index].mode;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.header.Details[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;

    this.getData();
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
